import { sendClientRequest } from '@/utils/client-request'

type SubmitArgs = {
  vendorId: string
  body: any
  session?: any
  auth: boolean
}

export const submitVendorReportApi = ({ vendorId, body, session, auth }: SubmitArgs) =>
  sendClientRequest({ url: '/vendorReport', method: 'POST', auth, session, headers: { Vendor: vendorId }, body })
